import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { BRAND } from "@/brand.config";

export default function ComingSoon({ testid = "coming-soon-page" }) {
  return (
    <div className="min-h-screen kazo-bg-black text-white flex flex-col" data-testid={testid}>
      <header className="px-6 lg:px-12 py-6">
        <Link to="/" data-testid="coming-soon-logo-link">
          <img src={BRAND.logoOnDarkUrl} alt={BRAND.legalName} className="h-9 w-auto" />
        </Link>
      </header>
      <main className="flex-1 flex items-center px-6 lg:px-12">
        <div className="max-w-2xl fade-up">
          <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-champagne mb-6 flex items-center gap-2">
            <Sparkles className="w-3.5 h-3.5" /> {BRAND.loyaltyProgramName}
          </div>
          <h1 className="editorial-headline text-5xl lg:text-7xl mb-6" data-testid="coming-soon-heading">
            Coming<br /><em className="font-light kazo-text-champagne">soon.</em>
          </h1>
          <p className="text-white/70 text-lg leading-relaxed mb-10">
            Our New U Rewards film is in the making. Until then, explore the programme and start earning on your beauty favourites.
          </p>
          <Link to="/" className="k-btn kazo-bg-burgundy uppercase tracking-widest text-xs font-semibold" data-testid="coming-soon-home-btn">
            Explore {BRAND.loyaltyProgramName}
          </Link>
        </div>
      </main>
      <footer className="px-6 lg:px-12 py-6 flex items-center gap-2 text-white/40">
        <span className="text-[10px] uppercase tracking-[0.2em]">Powered by</span>
        <img src={BRAND.platformLogoUrl} alt={BRAND.platform} className="h-3.5 w-auto opacity-90" />
      </footer>
    </div>
  );
}
